import { render } from "./UploadClusterMarkplus.vue?vue&type=template&id=5cae6b54&scoped=true"
import script from "./UploadClusterMarkplus.vue?vue&type=script&lang=js"
export * from "./UploadClusterMarkplus.vue?vue&type=script&lang=js"

import "./UploadClusterMarkplus.vue?vue&type=style&index=0&id=5cae6b54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5cae6b54"

export default script